import { useRef } from 'react';

import localStore from 'utils/localStore';

export default function useMasterData() {
  const masterData = useRef(JSON.parse(localStore.get('dictionary'))).current;

  return { masterData };
}
